import PropTypes from 'prop-types';
import React from 'react'
import { findWhere, findKey } from 'underscore'

import QuestionItem from './TemplateParts/QuestionItem'


export default class extends React.Component {
    static propTypes = {
		title: PropTypes.string.isRequired,
		questions: PropTypes.array.isRequired,
		changeData: PropTypes.func.isRequired,
		prevSlide: PropTypes.func.isRequired,
		nextSlide: PropTypes.func.isRequired,
	};

    constructor(props) {
        super(props);
        var completedQuestions = props.questions.filter(question => { return 'answer' in question });

        this.state = {
			questions: props.questions,
			completed: completedQuestions.length == props.questions.length
		};
    }

    changeMainAnswer = (field, value) => {

		var questions = this.state.questions,
			key = findKey(this.state.questions, function(question) { return question.field == field });
		questions[key].answer = value.toString();
		var completedQuestions = this.state.questions.filter(question => { return 'answer' in question });
		this.setState({
			questions: questions,
			completed: completedQuestions.length == this.state.questions.length
		})

		var data = {};
		data[ field ] = value
		this.props.changeData({}, data)

	};

    changeSubAnswer = (field, value) => {

		var questions = this.state.questions,
			key = findKey(this.state.questions, function(question) { return question.field == field });
		questions[key].subQuestion.answer = value;
		var completedQuestions = this.state.questions.filter(question => { return 'answer' in question });
		this.setState({
			questions: questions,
			completed: completedQuestions.length == this.state.questions.length
		})

		var data = {};
		data[ field + '_follow' ] = value
		this.props.changeData({}, data)

	};

    render() {

		return (

			<div>
				<div className="slide-wrapper">
					<header className="bg-deep-main ptop20 pbot20">
						<h4 className="text-white text-center mtop0 mbot0">{this.props.title}</h4>
					</header>
					<div className="inner bg-light-main bg-slightly-transparent">
						{ this.state.questions.map(question => {
							return <QuestionItem {...question} key={'question-'+question.field} changeMainAnswer={this.changeMainAnswer} changeSubAnswer={this.changeSubAnswer} />
						}) }
					</div>
					<footer className="bg-deep-main p20">
						<p className="lead mbot0 text-center text-white">
							<i className="icon icon-chevron-left pull-left clickable" onClick={this.props.prevSlide}></i>
							{ this.state.completed ? 'Continue' : '' }
							<i 	className={"icon icon-chevron-right pull-right clickable " + (!this.state.completed ? "text-dark-gray" : "")}
								onClick={this.state.completed ? this.props.nextSlide : false}></i>
						</p>
						<div className="clearfix"></div>
					</footer>
				</div>
			</div>

		)

	}
}



// WEBPACK FOOTER //
// ./src/js/views/Registration/RegistrationParts/QuestionsTemplate.jsx